<template>
  <div>
    <div>
      <h3>Project</h3>
    </div>
    <div class="wrapper">
      <div class="row row-wider">
        <div class="col-md-12" style="min-height: 150px;">
          <loader v-if="projectLoading" />
          <div v-if="project != null">
            <tabs nav-style="tabs" v-model="activeTabIndex">
              <tab header="Project">
                <projectHeader v-bind:project="project"/>
                <fieldset :disabled="formDisabled">
                    <form @submit.prevent="submit" class="form-horizontal" data-vv-scope="tabProject">
                        <div class="form-group" v-show="isExistingProject">
                            <label class="col-md-3 control-label">Project ID</label>
                            <div class="col-md-4">
                                <span class="textValue">{{ project.projectId }}</span>
                            </div>
                        </div>
                        <div class="form-group" v-bind:class="{ 'has-error': errors.has('tabProject.name') }">
                            <label class="col-md-3 control-label">Project Name</label>
                            <div class="col-md-5">
                                <input name="name" type="text" class="form-control" v-model="project.name" placeholder="Name" v-validate="'required'" aria-required="true">
                                <span v-show="errors.has('tabProject.name')" class="has-error">Name is required</span>
                            </div>
                        </div>
                        <div class="form-group" v-bind:class="{ 'has-error': errors.has('tabProject.projectTypeId') }">
                            <label class="col-md-3 control-label">Project Type</label>
                            <div class="col-md-6">
                                <select name="projectTypeId" class="form-control" v-model="project.projectTypeId" v-validate="'required'" aria-required="true">
                                    <option value="">Select a value</option>
                                    <option v-for="projectType in projectTypeList" :key="projectType.projectTypeId" :value="projectType.projectTypeId">
                                        {{ projectType.description}}
                                    </option>
                                </select>
                                <span v-show="errors.has('tabProject.projectTypeId')" class="has-error">Project Type is required</span>
                            </div>
                        </div>
                        <div class="form-group" v-bind:class="{ 'has-error': errors.has('tabProject.leadAgency') }">
                            <label class="col-md-3 control-label">Lead Agency</label>
                            <div class="col-md-8">
                                <select name="agencyId" class="form-control" v-model="project.agencyId" v-on:change="changeConfirm('agencyId', 'lead agency')" v-validate="'required'" aria-required="true">
                                    <option value="">Select a value</option>
                                    <option v-for="organization in leadOrganizationList" :key="organization.id" :value="organization.id">{{ organization.description}}</option>
                                </select>
                                <span v-show="errors.has('tabProject.leadAgency')" class="has-error">Lead Agency is required</span>
                                <span v-show="selectedLeadOrganization && selectedLeadOrganization.hasUsers === false && !selectedLeadOrganization.agencyNoReview" class="has-error">
                                    Selected Lead Agency has no Wyotrack users
                                </span>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-3 control-label">Agency Number</label>
                            <div class="col-md-5">
                                <input name="name" type="text" class="form-control" v-model="project.agencyNumber" placeholder="Agency Number">
                            </div>
                        </div>
                        <div class="form-group" v-bind:class="{ 'has-error': errors.has('tabProject.clientId') }">
                            <label class="col-md-3 control-label">Client</label>
                            <div class="col-md-8">
                                <input type="hidden" v-model="project.clientId" />
                                <select name="clientId" class="form-control" v-model="selectedClient" v-on:input="clientChange($event.target.value)" v-validate="'required'" aria-required="true">
                                    <option value="">Select a value</option>
                                    <option v-for="organization in organizationList" :key="organization.organizationId" :value="organization.organizationId">
                                        {{ organization.description}}
                                    </option>
                                </select>
                                <span v-show="errors.has('tabProject.clientId')" class="has-error">Client is required</span>
                            </div>
                        </div>
                        <!-- <div class="form-group">
                            <label class="col-md-3 control-label">Client</label>
                            <div class="col-md-8">
                                <v-select v-model="selectedClient" v-on:input="clientChange"
                                :options="organizationList" label="description"></v-select>
                            </div>
                        </div> -->
                        <!-- Field Org (consultant) form field -->
                        <div class="form-group">
                            <label class="col-md-3 control-label">Field Org.</label>
                            <div class="col-md-8">
                                <select name="fieldOrganizationId" class="form-control" v-model="project.fieldOrganizationId" v-on:change="changeConfirm('fieldOrganizationId', 'field org.')">
                                    <option value="">Select a value</option>
                                    <option v-for="organization in organizationList" :key="organization.organizationId" :value="organization.organizationId">
                                        {{ organization.description}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-3 control-label">Field Org. Number</label>
                            <div class="col-md-5">
                                <input name="name" type="text" class="form-control" v-model="project.fieldOrgNumber" placeholder="Field Org. Number">
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-3 control-label">Migrated References</label>
                            <div class="col-md-9">
                                <!-- <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Type</th>
                                            <th>Identifier</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="identifier in projectIdentifierList" :key="identifier.index">
                                            <td>{{identifier.typeDescription}}</td>
                                            <td>{{identifier.identifier}}</td>
                                        </tr>
                                    </tbody>
                                </table> -->
                                <div v-show="gridInvMigrationRef.tableData.length > 0">
                                    <v-client-table :data="gridInvMigrationRef.tableData" :columns="gridInvMigrationRef.columns" :options="gridInvMigrationRef.options">
                                </v-client-table>
                            </div>
                            </div>
                        </div>
                        <div class="form-group">

                        </div>

                        <!-- end Field Org (consultant form field) -->
                        <!-- inactive Status fields -->
                        <div class="form-group">
                            <label class="col-md-3 control-label">&nbsp;</label>
                            <div class="col-md-8">
                                <input type="checkbox" id="IsProjectInactive" v-model="project.inactive">
                                <label for="IsProjectInactive">Set Project Inactive?</label>
                            </div>
                        </div>
                        <div class="form-group" v-show="project.inactive">
                            <label class="col-md-3 control-label">&nbsp;</label>
                            <div class="col-md-8">
                                <textarea name="inactiveComment" class="form-control" v-model="project.inactiveComment" placeholder="Reasons for Inactive Project"></textarea>
                            </div>
                        </div>
                        <div class="form-group" v-show="project.inactive">
                            <label class="col-md-3 control-label text-label">Project Status Updated By</label>
                            <div class="col-md-4 text-label">
                                {{ project.inactiveBy }}
                            </div>
                        </div>
                        <div class="form-group" v-show="project.inactive">
                            <label class="col-md-3 control-label text-label">Project Status Updated At</label>
                            <div class="col-md-4 text-label">
                                {{ projectInactiveDateFormatted }}
                            </div>
                        </div>
                        <!-- end inactive Status fields -->
                        <div class="form-group">
                            <label class="col-md-3 control-label">&nbsp;</label>
                            <div class="col-md-8">
                                <input type="checkbox" id="IsFederalAgencyImpacted" v-model="project.isFederalAgencyImpacted" :disabled="!isFederalAgencyImpactedCheckboxEnabled">
                                <label for="IsFederalAgencyImpacted">Is this a federal undertaking?</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-3 control-label">&nbsp;</label>
                            <div class="col-md-8">
                                <input type="checkbox" id="expeditedReview" v-model="project.expeditedReview" >
                                <label for="expeditedReview">EO 14156</label>
                            </div>
                        </div>
                        <div class="form-group" v-show="isExistingProject">
                            <label class="col-md-3 control-label text-label">Created By</label>
                            <div class="col-md-4 text-label">
                                {{ project.createdBy }}
                            </div>
                        </div>
                        <div class="form-group" v-show="isExistingProject">
                            <label class="col-md-3 control-label text-label">Created Date</label>
                            <div class="col-md-4 text-label">
                                {{ projectCreatedDateFormatted }}
                            </div>
                        </div>
                        <div class="form-group" v-show="isExistingProject">
                            <label class="col-md-3 control-label text-label">Modified By</label>
                            <div class="col-md-4 text-label">
                                {{ project.modifiedBy }}
                            </div>
                        </div>
                        <div class="form-group" v-show="isExistingProject">
                            <label class="col-md-3 control-label text-label">Modified Date</label>
                            <div class="col-md-4 text-label">
                                {{ projectModifiedDateFormatted }}
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-3"></div>
                            <div class="col-md-8">
                                <div v-show="errors.any()">
                                    <span class="has-error">Validation issues must be corrected prior to submit</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-3"></div>
                            <div class="col-md-8">
                                <div v-show="serverErrorList.length > 0">
                                    <span class="has-error">Validation issues must be corrected prior to submit</span>
                                    <ul class="has-error">
                                        <li v-for="serverError in serverErrorList" :key="serverError">{{ serverError }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-3">
                            </div>
                            <div class="col-md-3" v-if="!formDisabled">
                                <button name="button2" class="btn btn-primary btn-block" type="submit" style="width:100px;">
                                    {{isExistingProject ? 'Save' : 'Create'}}
                                </button>
                            </div>
                        </div>
                    </form>
                </fieldset>
              </tab>
              <tab header="Building Survey" v-if="hasSurvey" :disabled="!isExistingProject">
                <projectHeader v-bind:project="project" />
                <buildingSurveyActions v-if="hasSurvey" :project="project"></buildingSurveyActions>
              </tab>
              <tab header="E106 Compliance" v-if="hasE106" :disabled="!isExistingProject">
                <projectHeader v-bind:project="project" />
                <e106ComplianceActions v-if="hasE106" :project="project"></e106ComplianceActions>
              </tab>
              <tab header="Actions" v-if="!hasSurvey && !hasE106" :disabled="!isExistingProject">
                <projectHeader v-bind:project="project" />
                <div class="tabContent">
                    <div class="sectionHeader">
                        <div class="sectionHeaderLeft">E106 Consultation Requests</div>
                        <div class="sectionHeaderRight" v-if="!formDisabled">
                            <router-link :to="{ path: '/E106Compliance', query: { projectId: project.projectId }}" tag="button" class="btn btn-primary btn-block">Add New</router-link>
                        </div>
                    </div>

                    <div style="float: clear" v-show="gridSpecCompliance.tableData.length > 0">
                        <v-client-table :data="gridSpecCompliance.tableData" :columns="gridSpecCompliance.columns" :options="gridSpecCompliance.options">
                        <template slot="edit" slot-scope="props" v-if="!isClientUser">
                            <div style="text-align: center;">
                                <router-link :to="{ path: '/E106Compliance/' + props.row.e106complianceId }" tag="a" class="fa fa-edit" style="font-size: 18px;"></router-link>
                            </div>
                        </template>
                        <template slot="delete" slot-scope="props">
                            <div style="text-align: center;" v-if="!formDisabled">
                                <a class="fa fa-ban" style="font-size: 18px;" v-if="props.row.canBeDeleted" v-on:click="deleteCompliance(props.row.e106complianceId)"></a>
                            </div>
                        </template>
                        </v-client-table>
                    </div>
                    <div class="sectionHeader">
                        <div class="sectionHeaderLeft">Fieldwork Requests</div>
                        <div class="sectionHeaderRight" v-if="!formDisabled">
                            <router-link :to="{ path: '/FieldWorkRequest', query: { projectId: project.projectId }}" tag="button" class="btn btn-primary btn-block">Add New</router-link>
                        </div>
                    </div>

                    <div style="float: clear" v-show="gridSpecFielworkRequests.tableData.length > 0">
                        <v-client-table :data="gridSpecFielworkRequests.tableData" :columns="fwrGridSpecColumns" :options="gridSpecFielworkRequests.options">
                        <template slot="edit" slot-scope="props">
                            <div style="text-align: center;" v-if="!isClientUser">
                                <router-link :to="{ path: '/FieldWorkRequest/' + props.row.fieldworkRequestId }" tag="a" class="fa fa-edit" style="font-size: 18px;"></router-link>
                            </div>
                        </template>
                        <template slot="delete" slot-scope="props">
                            <div style="text-align: center;" v-if="!formDisabled">
                                <a class="fa fa-ban" style="font-size: 18px;" v-if="props.row.canBeDeleted" v-on:click="deleteFieldworkRequest(props.row.fieldworkRequestId)"></a>
                            </div>
                        </template>
                        </v-client-table>
                    </div>
                    <template v-if="!isAgencyReadOnly">
                      <div class="sectionHeader">
                          <div class="sectionHeaderLeft">File Search</div>
                          <div class="sectionHeaderRight" v-if="!formDisabled"><router-link :to="{ path: '/FileSearch', query: { projectId: project.projectId }}" tag="button" class="btn btn-primary btn-block">Add New</router-link></div>
                      </div>

                      <div style="float: clear" v-show="gridSpecFileSearches.tableData.length > 0">
                          <v-client-table :data="gridSpecFileSearches.tableData" :columns="gridSpecFileSearches.columns" :options="gridSpecFileSearches.options">
                              <template slot="edit" slot-scope="props" v-if="!isClientUser">
                                  <div style="text-align: center;">
                                      <router-link :to="{ path: '/FileSearch/' + props.row.fileSearchId }" tag="a" class="fa fa-edit" style="font-size: 18px;"></router-link>
                                  </div>
                              </template>
                              <template slot="result" slot-scope="props" v-if="!isClientUser">
                                  <div style="text-align: center;" v-if="props.row.hasResults">
                                      <router-link :to="{ path: '/FileSearch/' + props.row.fileSearchId, hash: '#files' }" tag="a" class="fa fa-edit" style="font-size: 18px;"></router-link>
                                  </div>
                              </template>
                              <template slot="delete" slot-scope="props">
                                  <div style="text-align: center;" v-if="!formDisabled">
                                      <a class="fa fa-ban" style="font-size: 18px;" v-if="props.row.canBeDeleted" v-on:click="deleteFileSearch(props.row)"></a>
                                  </div>
                              </template>
                          </v-client-table>
                      </div>
                    </template>

                    <div class="sectionHeader">
                        <div class="sectionHeaderLeft">Investigation</div>
                        <div class="sectionHeaderRight" v-if="!formDisabled">
                            <button name="buttonAddInvestigation" class="btn btn-primary btn-block" v-on:click="addInvestigation">Add New</button>
                        </div>
                    </div>
                    <modal  ref="investigationModal">
                        <h3 slot="header">File Search Missing</h3>
                        <div slot="body">
                                Before performing an investigation with a level 2 or level 3 survey, an official File Search must be completed. Would you like to create a file search, or continue to the investigation?
                        </div>
                        <div slot="footer">
                            <div class="row">
                                <router-link :to="{ path: '/FileSearch', query: { projectId: project.projectId }}" tag="button" class="btn btn-primary col-md-3">File Search</router-link>
                                <router-link :to="{ path: '/Investigation', query: { projectId: project.projectId}}" tag="button" class="btn btn-primary col-md-3">Continue</router-link>
                                <button name="buttonCancel" class="btn btn-primary col-md-3" v-on:click="$refs['investigationModal'].close()"> Cancel </button>
                            </div>
                        </div>
                    </modal>
                    <div style="float: clear" v-show="gridSpecInvestigations.tableData.length > 0">
                        <v-client-table :data="gridSpecInvestigations.tableData" :columns="gridSpecInvestigations.columns" :options="gridSpecInvestigations.options">
                        <template slot="edit" slot-scope="props">
                            <div style="text-align: center;">
                                <router-link :to="{ path: '/Investigation/' + props.row.investigationId }" tag="a" class="fa fa-edit" style="font-size: 18px;"></router-link>
                            </div>
                        </template>
                        <template slot="resources" slot-scope="props">
                            <div style="text-align: center;">
                                <span v-if="props.row.siteCount > 0 || props.row.isolateCount > 0">Yes&nbsp;</span>
                                <router-link :to="{ path: '/Investigation/' + props.row.investigationId, hash: '#siteSummary' }" tag="a" class="fa fa-edit" style="font-size: 16px;" v-if="props.row.siteCount > 0 || props.row.isolateCount > 0"></router-link>
                                <span v-else>No</span>
                            </div>
                        </template>
                        <template slot="delete" slot-scope="props">
                            <div style="text-align: center;" v-if="!formDisabled">
                                <a class="fa fa-ban" style="font-size: 18px;" v-if="props.row.canBeDeleted" v-on:click="deleteInvestigation(props.row)"></a>
                            </div>
                        </template>
                        </v-client-table>
                    </div>
                    <div v-if="!isConsultant">
                        <div class="sectionHeader">
                            <div class="sectionHeaderLeft">Undertaking</div>
                        </div>
                        <div style="float: clear" v-show="gridSpecUt.tableData.length > 0">
                            <v-client-table :data="gridSpecUt.tableData" :columns="gridSpecUt.columns" :options="gridSpecUt.options">
                            <template slot="edit" slot-scope="props">
                                <div style="text-align: center;">
                                    <router-link :to="{ path: '/Undertaking/' + props.row.undertakingId }" tag="a" class="fa fa-edit" style="font-size: 18px;"></router-link>
                                </div>
                            </template>
                            </v-client-table>
                        </div>
                        <div class="sectionHeader">
                            <div class="sectionHeaderLeft">MOA/PA</div>
                        </div>
                        <div style="float: clear" v-show="gridSpecMoa.tableData.length > 0">
                            <v-client-table :data="gridSpecMoa.tableData" :columns="gridSpecMoa.columns" :options="gridSpecMoa.options">
                            <template slot="edit" slot-scope="props">
                                <div style="text-align: center;">
                                    <router-link :to="{ path: '/Moa/' + props.row.moaId }" tag="a" class="fa fa-edit" style="font-size: 18px;"></router-link>
                                </div>
                            </template>
                            </v-client-table>
                        </div>
                        <div style="float: clear" v-show="gridSpecPa.tableData.length > 0">
                            <v-client-table :data="gridSpecPa.tableData" :columns="gridSpecPa.columns" :options="gridSpecPa.options">
                            <template slot="edit" slot-scope="props">
                                <div style="text-align: center;">
                                    <router-link :to="{ path: '/Pa/' + props.row.paId }" tag="a" class="fa fa-edit" style="font-size: 18px;"></router-link>
                                </div>
                            </template>
                            </v-client-table>
                        </div>
                    </div>
                </div>
              </tab>
              <tab header="Organizations" :disabled="!isExistingProject" v-if="!isAgencyReadOnly && !isClientUser">
                <projectHeader v-bind:project="project" />

                <div class="sectionHeader">
                    <div class="sectionHeaderLeft">View Only Organizations</div>
                    <div class="sectionHeaderRight">
                        <div class="form-group" style="padding-right: 12px;">
                            <div v-if="showAddViewOnlyOrganization">
                                <label class="col-md-3 control-label" for="searchFieldOrgName">Field Org. Name</label>
                                <div class="col-md-5">
                                    <select name="fieldOrganizationId" class="form-control" v-model="projectViewOnlyOrganizationId">
                                        <option value="">Select a value</option>
                                        <option v-for="organization in organizationList" :key="organization.organizationId" :value="organization.organizationId">
                                            {{ organization.description}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="btn" :class="showAddViewOnlyOrganization ? 'btn-danger btn col-md-4' : 'btn-primary'" v-if="!formDisabled" @click="handleViewOnlyOrganization" >{{showAddViewOnlyOrganization ? 'Grant View Only Access' : 'Add New'}}</div>
                        </div>
                    </div>
                    <div style="float: clear" v-show="gridProjectViewOnlyOrganizations">
                        <v-client-table :data="gridProjectViewOnlyOrganizations.tableData" :columns="gridProjectViewOnlyOrganizations.columns" :options="gridProjectViewOnlyOrganizations.options">
                            <template slot="delete" slot-scope="props">
                                <div style="text-align: center;" v-if="!formDisabled">
                                    <a class="fa fa-ban" style="font-size: 18px;" v-on:click="deleteProjectOrgViewOnly(props.row)"></a>
                                </div>
                            </template>
                        </v-client-table>
                    </div>
                </div>

                <div class="sectionHeader">
                    <div class="sectionHeaderLeft">Project Organization History</div>
                </div>
                <div style="float: clear" v-show="gridProjectOrganizationHistory.tableData.length > 0">
                    <v-client-table :data="gridProjectOrganizationHistory.tableData" :columns="gridProjectOrganizationHistory.columns" :options="gridProjectOrganizationHistory.options">
                    </v-client-table>
                </div>
              </tab>
            </tabs>
          </div>
        </div>
      </div>
    </div>

    <div v-show="isDebug">
        <div>
            <h3 class="text-danger">****** Debug ******</h3>
        </div>
        <div>
            <h4>project: </h4>
            <pre>{{ project }}</pre>
        </div>
        <div>
            <h4>Validation errors: </h4>
            <pre>{{ errors }}</pre>
        </div>
        <div>
            <h4>selectedLeadOrganization: </h4>
            <pre>{{ selectedLeadOrganization }}</pre>
        </div>
        <div>
            <h4>isFederalAgencyImpactedCheckboxEnabled: </h4>
            <pre>{{ isFederalAgencyImpactedCheckboxEnabled }}</pre>
        </div>
        <div>
            <h4>hasSurvey: </h4>
            <pre>{{ hasSurvey }}</pre>
        </div>
    </div>
  </div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import dateService from '../services/util/dateService'
import projectService from '../services/projectService'
import projectOrganizationViewOnlyService from '../services/projectOrganizationViewOnlyService'
import organizationService from '../services/organizationService'
import userService from '@/services/userService'
import projectTypeService from '../services/lookup/projectTypeService'
import fieldworkRequestService from '../services/fieldworkRequestService'
import fileSearchService from '../services/fileSearchService'
import investigationService from '../services/investigationService'
import buildingSurveyService from '../services/buildingSurveyService'
import roleService from '../services/roleService.js'
import moaService from '../services/moaService'
import paService from '../services/paService'
import undertakingService from '../services/undertakingService'
import e106ComplianceService from '@/services/e106ComplianceService'
import { mapState } from 'vuex'
import vSelect from 'vue-select'

import projectHeader from '../components/ProjectHeader.vue'
import loader from '../components/Loader.vue'
import modal from '../components/Modal.vue'
import buildingSurveyActions from '../components/BuildingSurveyActions.vue'
import e106ComplianceActions from '../components/E106ComplianceActions.vue'
import { tab, tabs } from 'vue-strap'
import _ from 'lodash/lodash.min.js'

export default {
    components: {
        tabs,
        tab,
        loader,
        projectHeader,
        modal,
        buildingSurveyActions,
        e106ComplianceActions,
        vSelect
    },
    data: function () {
        return {
            clientIdCurrent: '',
            agencyIdCurrent: '',
            fieldOrganizationIdCurrent: '',
            isDebug: false,
            activeTabIndex: (this.$route.params.projectId) ? 1 : 0,
            projectLoading: false,
            project: {},
            leadOrganizationList: [],
            organizationList: [{description: ''}],
            projectTypeList: [],
            serverErrorList: [],
            projectIdentifierTypeList: projectService.getIdentifierTypeList(),
            selectedLeadOrganization: null,
            isFederalAgencyImpactedCheckboxEnabled: false,
            gridSpecFielworkRequests: {
                columns: ['edit', 'workflowStatusDescription', 'dbNumber', 'fieldOrganizationProjectNumber', 'fieldOrganizationDescription', 'agencyDescription', 'proposedStartDate', 'proposedEndDate', 'delete'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['proposedStartDate', 'proposedEndDate'],
                    headings: {
                        edit: 'View/Edit',
                        workflowStatusDescription: 'Status',
                        dbNumber: 'DB Number',
                        fieldOrganizationProjectNumber: 'Field Org Project Number',
                        fieldOrganizationDescription: 'Field Org Description',
                        agencyDescription: 'Lead Agency',
                        proposedStartDate: 'Start Date',
                        proposedEndDate: 'End Date',
                        inactiveDisplay: 'Inactive',
                        delete: 'Delete'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'proposedStartDate'
                    }
                }
            },
            gridSpecFileSearches: {
                columns: ['edit', 'workflowStatusDescription', 'fileSearchId', 'createdDate', 'plssLocationCount', 'billAmount', 'result', 'delete'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['createdDate'],
                    headings: {
                        fileSearchId: 'File Search #',
                        createdDate: 'Date of Entry',
                        workflowStatusDescription: 'Status',
                        plssLocationCount: '# of Sections',
                        billAmount: 'Bill Amount',
                        delete: 'Delete'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'createdDate'
                    }
                }
            },
            gridSpecInvestigations: {
                columns: ['edit', 'workflowStatusDescription', 'dbNumber', 'reportTitle', 'reportDate', 'resources', 'assignedAgent', 'fieldworkStartDate', 'delete'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['reportDate', 'fieldworkStartDate'],
                    headings: {
                        edit: 'View/Edit',
                        workflowStatusDescription: 'Status',
                        dbNumber: 'DB Number',
                        reportDate: 'Report Date',
                        reportTitle: 'Report Title',
                        resources: 'Resources',
                        assignedAgent: 'Assigned Agent',
                        fieldworkStartDate: 'Fieldwork Start Date',
                        delete: 'Delete'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'reportDate'
                    }
                }
            },
            gridSpecMoa: {
                columns: ['edit', 'workflowStatusDescription', 'dbnumber', 'moaName', 'effectiveDate', 'createdDate'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['effectiveDate', 'createdDate'],
                    headings: {
                        moaName: 'Name',
                        dbnumber: 'DB Number',
                        effectiveDate: 'Effective Date',
                        createdDate: 'Created Date',
                        workflowStatusDescription: 'Status'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'createdDate'
                    }
                }
            },
            gridSpecPa: {
                columns: ['edit', 'workflowStatusDescription', 'dbnumber', 'paName', 'effectiveDate', 'createdDate'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['effectiveDate', 'createdDate'],
                    headings: {
                        paName: 'Name',
                        dbnumber: 'DB Number',
                        effectiveDate: 'Effective Date',
                        createdDate: 'Created Date',
                        workflowStatusDescription: 'Status'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'createdDate'
                    }
                }
            },
            gridSpecUt: {
                columns: ['edit', 'workflowStatusDescription', 'dbNumber', 'name', 'effect', 'reviewTimeframe', 'createdDate'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['createdDate'],
                    headings: {
                        name: 'Name',
                        dbNumber: 'DB Number',
                        createdDate: 'Created Date',
                        workflowStatusDescription: 'Status',
                        effect: 'Finding of Effect',
                        reviewTimeframe: 'Review Timeframe'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'createdDate'
                    }
                }
            },
            gridProjectOrganizationHistory: {
                columns: ['agencyDescription', 'clientDescription', 'fieldOrgDescription', 'createdBy', 'createdDateFormatted'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['modifiedDate'],
                    headings: {
                        agencyDescription: 'Lead Agency',
                        clientDescription: 'Client',
                        fieldOrgDescription: 'Field Org.',
                        createdBy: 'Change By',
                        createdDateFormatted: 'Change Date'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'createdDateFormatted'
                    }
                }
            },
            gridProjectViewOnlyOrganizations: {
                columns: ['organizationDescription', 'createdBy', 'createdDate', 'delete'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['createdDate'],
                    headings: {
                        organizationDescription: 'Org. Name',
                        createdBy: 'Added By',
                        createdDate: 'Added Date.',
                        delete: 'Delete'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'createdDateFormatted'
                    }
                }
            },
            gridInvMigrationRef: {
                columns: ['investigationDbNumber', 'rcRevno', 'n9recId', 'acno'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    headings: {
                        investigationDbNumber: 'DB Number',
                        rcRevno: 'Rev No',
                        n9recId: 'N9RecId',
                        acno: 'ACNO'
                    },
                    filterable: false
                }
            },
            gridSpecCompliance: {
                columns: ['edit', 'workflowStatusDescription', 'projectDescription', 'createdDate', 'delete'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 5,
                    perPageValues: [5, 10, 25],
                    dateColumns: ['reportDate'],
                    headings: {
                        edit: 'View/Edit',
                        workflowStatusDescription: 'Status',
                        projectDescription: 'Project Description',
                        createdDate: 'Created Date',
                        delete: 'Delete'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'createdDate'
                    }
                }
            },
            projectIdentifierList: [],
            showInvestigationModal: false,
            selectedClient: {},
            showAddViewOnlyOrganization: false,
            projectViewOnlyOrganizationId: null
        }
    },
    computed: {
        // compute current user info
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        projectCreatedDateFormatted: function () {
            return dateService.toString(this.project.createdDate)
        },
        projectModifiedDateFormatted: function () {
            return dateService.toString(this.project.modifiedDate)
        },
        projectInactiveDateFormatted: function () {
            return this.project.inactiveDate ? dateService.toString(this.project.inactiveDate) : ''
        },
        isExistingProject: function () {
            return this.project.projectId && this.project.projectId !== 0
        },
        leadAgencyId: function () {
            return (this.project) ? this.project.agencyId : null
        },
        isCLGConsultant: function () {
            return (userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.CLGConsultant]))
        },
        isE106User: function () {
            return (userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.E106User]))
        },
        isConsultant: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ConsultantOnlyRoleList)
        },
        isShpo: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoRoleList)
        },
        isAgencyUser: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.BlmUser])
        },
        isShpoReadOnly: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoReadOnlyRoleList)
        },
        isAgencyReadOnly: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.RestrictedRoleList) ||
                (this.gridProjectViewOnlyOrganizations.tableData.some(o => o.organizationId === this.shpoUserDto.organizationId) && this.isAgencyUser)
        },
        isClientUser: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.ClientUser])
        },
        leadAgencyDescription: function () {
            if (this.project) {
                var leadAgency = this.leadOrganizationList.find(organization => { return organization.id === this.project.agencyId })
                return (leadAgency) ? leadAgency.description : null
            }
        },
        clientDescription: function () {
            if (this.project) {
                var client = this.organizationList.find(organization => { return organization.organizationId === this.project.clientId })
                return (client) ? client.description : null
            }
        },
        hasSurvey: function () {
            return (this.isCLGConsultant && !this.isExistingProject) || (this.project && this.project.hasSurvey)
        },
        hasE106: function () {
            return (this.isE106User && !this.isExistingProject) || (this.project && this.project.hasE106)
        },
        fwrGridSpecColumns: function () {
            var columns = ['edit', 'workflowStatusDescription', 'dbNumber', 'fieldOrganizationProjectNumber', 'fieldOrganizationDescription', 'agencyDescription', 'proposedStartDate', 'proposedEndDate']
            if (this.isShpo) {
                return columns.concat(['inactiveDisplay', 'delete'])
            } else {
                columns.push('delete')
                return columns
            }
        },
        formDisabled: function () {
            return this.isShpoReadOnly || this.isAgencyReadOnly || this.isClientUser
        }
    },
    mounted () {
        loggingService.log(this.isDebug, 'Project', 'mounted')

        this.projectLoading = true
        Promise.all([ this.loadLeadOrganizationList(this), this.loadOrganizations(), this.loadProjectTypeList() ]).then(results => {
            this.project = {}
            var projectId = this.$route.params.projectId
            loggingService.log(this.isDebug, 'Project', 'mounted, post promises, projectId: ' + projectId)

            if (projectId) {
                this.loadProject(projectId)
            } else {
                this.project = this.createNewProject()
                this.projectLoading = false
            }
        })
    },
    watch: {
        activeTabIndex: function (val) {
            loggingService.log(this.isDebug, 'Project', 'watch.activeTabIndex: ' + val)
            switch (val) {
            case 1:
                break
            case 2:
                break
            }
        },
        leadAgencyId: function (val) {
            loggingService.log(this.isDebug, 'Project', 'watch.leadAgencyId: ' + val)
            this.selectedLeadOrganization = this.getSelectedLeadOrganizationList(val)
            if (this.selectedLeadOrganization) {
                this.project.isFederalAgencyImpacted = this.selectedLeadOrganization.isFederalAgency
                this.isFederalAgencyImpactedCheckboxEnabled = this.selectedLeadOrganization.is106Agency
            }
        }
    },
    methods: {
        loadProject (projectId) {
            loggingService.log(this.isDebug, 'Project', 'loadProject')
            var handle = this
            projectService.get(this.$http, projectId).then(function (response) {
                handle.project = response.data
                handle.clientIdCurrent = handle.project.clientId
                handle.agencyIdCurrent = handle.project.agencyId
                handle.fieldOrganizationIdCurrent = handle.project.fieldOrganizationId

                //set selectedClient
                handle.selectedClient = handle.project.clientId

                // iterate the data list and add agency, client, field org descriptions
                var projectOrgHistoryData = handle.loadProjectOrgHistoryData(handle.project.projectOrganizationHistoryList)

                handle.gridProjectOrganizationHistory.tableData = projectOrgHistoryData

                handle.loadProjectViewOnlyOrganizations()

                var promise1 = fieldworkRequestService.listByProjectId(handle.$http, projectId).then(function (response1) {
                    loggingService.log(handle.isDebug, 'Project', 'loadProject - fieldworkRequestService.listByProjectId')
                    handle.gridSpecFielworkRequests.tableData = response1.data
                })

                var fileSearchSearchDto = {
                    StartDate: '',
                    EndDate: '',
                    ProjectId: projectId
                }
                var promise2 = fileSearchService.search(handle.$http, fileSearchSearchDto).then(function (response1) {
                    loggingService.log(handle.isDebug, 'Project', 'loadProject - fileSearchService.search')
                    handle.gridSpecFileSearches.tableData = response1.data
                })

                var searchDto = {
                    ProjectId: projectId
                }
                var promise3 = investigationService.search(handle.$http, searchDto).then(function (response2) {
                    loggingService.log(handle.isDebug, 'Project', 'loadProject - investigationService.search')
                    handle.gridSpecInvestigations.tableData = response2.data
                })
                var promise4 = projectService.searchProjectIdentifier(handle.$http, {projectId: projectId}).then(function (response) {
                    loggingService.log(handle.isDebug, 'Project', 'loadProject - searchProjectIdentifier, count:' + response.data.length)
                    handle.projectIdentifierList = response.data.map(x => {
                        x.typeDescription = (handle.projectIdentifierTypeList.find(y => y.projectIdentifierTypeId === x.projectIdentifierTypeId) || { description: '' }).description
                        return x
                    })
                })
                if (!handle.isConsultant) {
                    var promise5 = undertakingService.search(handle.$http, searchDto).then(response => {
                        loggingService.log(handle.isDebug, 'Project', 'loadProject - undertakingService.search')
                        handle.gridSpecUt.tableData = response.data
                    })
                    var promise6 = moaService.search(handle.$http, searchDto).then(response => {
                        loggingService.log(handle.isDebug, 'Project', 'loadProject - moaService.search')
                        handle.gridSpecMoa.tableData = response.data
                    })
                    var promise7 = paService.search(handle.$http, searchDto).then(response => {
                        loggingService.log(handle.isDebug, 'Project', 'loadProject - paService.search')
                        handle.gridSpecPa.tableData = response.data
                    })
                }

                var promise8 = projectService.listInvMigrationRefs(handle.$http, projectId).then(resp => {
                    handle.gridInvMigrationRef.tableData = resp.data
                })

                var promise9 = e106ComplianceService.search(handle.$http, searchDto).then(response => {
                    loggingService.log(handle.isDebug, 'Project', 'loadProject - e106ComplianceService.search')
                    handle.gridSpecCompliance.tableData = response.data
                })

                Promise.all([promise1, promise2, promise3, promise4, promise5, promise6, promise7, promise8, promise9]).then(results => {
                    loggingService.log(handle.isDebug, 'Project', 'loadProject - then')
                    handle.projectLoading = false
                })
            })
        },
        createNewProject () {
            return {
                projectId: 0,
                name: null,
                projectTypeId: this.populateProjectType(),
                agencyId: this.populateAgency(),
                clientId: '',
                fieldOrganizationId: this.populateFieldOrg(),
                isFederalAgencyImpacted: ''
            }
        },
        loadLeadOrganizationList () {
            loggingService.log(this.isDebug, 'Project', 'loadLeadOrganizationList')
            this.leadOrganizationList = []
            var handle = this
            return organizationService.listLeadAgencyLookup(handle.$http).then(function (response) {
                handle.leadOrganizationList = response.data
            })
        },
        loadOrganizations () {
            loggingService.log(this.isDebug, 'Project', 'loadOrganizations')
            this.organizationList = []
            var handle = this
            return organizationService.listLookup(this.$http).then(function (response) {
                handle.organizationList = response.data
            })
        },
        loadProjectTypeList () {
            loggingService.log(this.isDebug, 'Project', 'loadProjectTypeList')
            this.projectTypeList = []
            var handle = this
            return projectTypeService.listLookup(this.$http).then(function (response) {
                handle.projectTypeList = response.data
                if (handle.isCLGConsultant) {
                    handle.projectTypeList = handle.projectTypeList.filter(x => x.description === 'HPF Programs--Survey')
                }
            })
        },
        submit () {
            loggingService.log(this.isDebug, 'Project', 'submit')
            this.projectLoading = true
            this.$validator.validateAll('tabProject').then(result => {
                if (result) {
                    loggingService.log(this.isDebug, 'Project', 'submit - form validated')

                    this.serverErrorList = []
                    var handle = this
                    projectService.put(this.$http, this.project).then(function (response) {
                        var result = response.data
                        if (result.isValid) {
                            handle.project = result.objectList[0]
                            var secondaryObject = result.objectList[1]
                            if (secondaryObject) {
                                loggingService.log(handle.isDebug, 'Project', 'Has secondary object')
                                if (secondaryObject.hasOwnProperty('fieldworkRequestId')) {
                                    loggingService.log(handle.isDebug, 'Project', 'secondary Object is FWR')
                                    handle.$router.push(fieldworkRequestService.getUrlByObject(secondaryObject))
                                } else if (secondaryObject.hasOwnProperty('buildingSurveyId')) {
                                    loggingService.log(handle.isDebug, 'Project', 'secondary Object is buildingSurvey')
                                    handle.$router.push(buildingSurveyService.getUrlByObject(secondaryObject))
                                } else if (secondaryObject.hasOwnProperty('e106complianceId')) {
                                    loggingService.log(handle.isDebug, 'Project', 'secondary Object is buildingSurvey')
                                    handle.$router.push(e106ComplianceService.getUrlByObject(secondaryObject))
                                } else if (secondaryObject.hasOwnProperty('fileSearchId')) {
                                    loggingService.log(handle.isDebug, 'Project', 'secondary Object is FS')
                                    handle.$router.push(fileSearchService.getUrlByObject(secondaryObject))
                                } else {
                                    console.log('project created, unknown redirect')
                                }
                            } else {
                                // reload project if this is an edit save
                                handle.$router.push('/Project/' + handle.project.projectId)
                                handle.loadProject(handle.project.projectId)
                            }
                        } else {
                            handle.serverErrorList = result.messages
                        }
                        handle.projectLoading = false
                    })
                } else {
                    loggingService.log(this.isDebug, 'Project', 'submit - invalid form')
                    handle.projectLoading = false
                }
            })
        },
        addInvestigation () {
            loggingService.log(this.isDebug, 'Project', 'checking before adding investigation')
            if (this.gridSpecFileSearches.tableData.length === 0) {
                loggingService.log(this.isDebug, 'Project', `No file searches, opening dialog, ref length: ${this.$refs}`)
                this.$refs['investigationModal'].open()
            } else {
                loggingService.log(this.isDebug, 'Project', 'forwarding')
                this.$router.push('/Investigation?projectId=' + this.project.projectId)
            }
        },
        getSelectedLeadOrganizationList (organizationId) {
            return _.find(this.leadOrganizationList, function (item) { return item.id === organizationId })
        },
        // confirm client change, set idCurrent to new id if confirmed
        changeConfirm: function (field, msg) {
            // confirm only if this is not a new project
            if (this.project.projectId !== 0) {
                if (this[field + 'Current']) {
                    if (confirm('Are you sure you want to change current ' + msg + '?')) {
                        this[field + 'Current'] = this.project[field]
                    } else {
                        this.project[field] = this[field + 'Current']
                    }
                } else {
                    this[field + 'Current'] = this.project[field]
                }
            }
        },
        populateProjectType: function () {
            if (this.shpoUserDto.roleList.includes(roleService.RoleEnum.CLGConsultant)) {
                return this.projectTypeList.find(x => { return x.description === 'HPF Programs--Survey' }).projectTypeId
            } else {
                return ''
            }
        },
        populateAgency: function () {
            loggingService.log(this.isDebug, 'Project', 'looking at pop agency')
            if (this.shpoUserDto.roleList.includes(roleService.RoleEnum.CLGConsultant)) {
                loggingService.log(this.isDebug, 'Project', 'Count: ' + this.leadOrganizationList.length)
                var orgId = this.leadOrganizationList.find(x => { return x.description === 'Wyoming SHPO' }).id
                loggingService.log(this.isDebug, 'Project', 'found orgId: ' + orgId)
                return orgId
            } else if (this.shpoUserDto.roleList.includes(roleService.RoleEnum.BlmUser) && (this.shpoUserDto.userOrganizationList.length > 0)) {
                return this.shpoUserDto.userOrganizationList[0].organizationId
            } else {
                return ''
            }
        },
        populateFieldOrg: function () {
            loggingService.log(this.isDebug, 'Project', 'Field org set: ' + this.shpoUserDto.userOrganizationList)
            loggingService.log(this.isDebug, 'Project', 'user org length : ' + this.shpoUserDto.userOrganizationList.length)
            if ((this.shpoUserDto.roleList.includes(roleService.RoleEnum.ConsultantUser) || this.shpoUserDto.roleList.includes(roleService.RoleEnum.CLGConsultant) ||
            this.shpoUserDto.roleList.includes(roleService.RoleEnum.E106User)) &&
                (this.shpoUserDto.userOrganizationList.length > 0)) {
                return this.shpoUserDto.userOrganizationList[0].organizationId
            } else {
                return ''
            }
        },
        loadProjectOrgHistoryData: function (dataList) {
            dataList.map(data => {
                var agency = this.leadOrganizationList.find(leadOrg => {
                    return leadOrg.id === data.agencyId
                })

                var client = this.organizationList.find(org => {
                    return org.organizationId === data.clientId
                })

                var fieldOrg = this.organizationList.find(org => {
                    return org.organizationId === data.fieldOrganizationId
                })

                data.agencyDescription = agency ? agency.description : ''
                data.clientDescription = client ? client.description : ''
                data.fieldOrgDescription = fieldOrg ? fieldOrg.description : ''
                var dateFormat = dateService.toString(data.createdDate)
                data.createdDateFormatted = dateFormat
            })
            return dataList
        },
        loadProjectViewOnlyOrganizations: function () {
            projectOrganizationViewOnlyService.getList(this.$http, this.project.projectId).then(res => {
                this.gridProjectViewOnlyOrganizations.tableData = res.data
            })
        },
        clientChange (value) {
            if (value === this.project.clientId) {
                return
            }
            if (this.project.projectId && this.project.projectId !== 0) {
                if (confirm('Are you sure you want to change the current client?')) {
                    this.project.clientId = value
                } else {
                    setTimeout(() => {
                        this.selectedClient = this.project.clientId
                    }, 10)
                }
            } else {
                this.project.clientId = value
            }
        },
        deleteFieldworkRequest (fieldworkRequestId) {
            var handle = this
            fieldworkRequestService.deleteFieldworkRequest(handle.$http, fieldworkRequestId).then(function () {
                fieldworkRequestService.listByProjectId(handle.$http, handle.project.projectId).then(function (response) {
                    loggingService.log(handle.isDebug, 'Project', 'deleteFieldworkRequest - fieldworkRequestService.listByProjectId')
                    handle.gridSpecFielworkRequests.tableData = response.data
                })
            })
        },
        deleteFileSearch (fileSearch) {
            var handle = this
            if (confirm(`Are you sure you wish to delete file search #${fileSearch.fileSearchId}`)) {
                fileSearchService.deleteFileSearch(handle.$http, fileSearch.fileSearchId).then(function () {
                    var fileSearchSearchDto = {
                        StartDate: '',
                        EndDate: '',
                        ProjectId: handle.project.projectId
                    }
                    fileSearchService.search(handle.$http, fileSearchSearchDto).then(function (response) {
                        loggingService.log(handle.isDebug, 'Project', 'deleteFileSearch - fileSearchService.search')
                        handle.gridSpecFileSearches.tableData = response.data
                    })
                })
            }
        },
        deleteInvestigation (investigation) {
            var handle = this
            if (confirm(`Are you sure you wish to delete investigation ${investigation.reportTitle}`)) {
                investigationService.deleteInvestigation(handle.$http, investigation.investigationId).then(function () {
                    var searchDto = {
                        ProjectId: handle.project.projectId
                    }
                    investigationService.search(handle.$http, searchDto).then(function (response) {
                        loggingService.log(handle.isDebug, 'Project', 'deleteInvestigation - investigationService.search')
                        handle.gridSpecInvestigations.tableData = response.data
                    })
                })
            }
        },
        deleteCompliance (complianceId) {
            var handle = this
            e106ComplianceService.remove(handle.$http, complianceId).then(() => {
                var searchDto = {
                    ProjectId: this.project.projectId
                }
                e106ComplianceService.search(handle.$http, searchDto).then(response => {
                    loggingService.log(handle.isDebug, 'Project', 'deleteCompliance - e106ComplianceService.search')
                    this.gridSpecCompliance.tableData = response.data
                })
            })
        },
        deleteProjectOrgViewOnly (viewOnly) {
            if (!confirm('Are you sure you want to delete the view only organization?')) {
                return
            }

            projectOrganizationViewOnlyService.remove(this.$http, viewOnly.id).then(() => {
                this.gridProjectViewOnlyOrganizations.tableData = this.gridProjectViewOnlyOrganizations.tableData.filter(o => o.id !== viewOnly.id)
            })
        },
        handleViewOnlyOrganization () {
            if (!this.showAddViewOnlyOrganization || !this.projectViewOnlyOrganizationId) {
                this.showAddViewOnlyOrganization = !this.showAddViewOnlyOrganization
                return
            }

            this.showAddViewOnlyOrganization = !this.showAddViewOnlyOrganization

            if (!confirm('Are you sure you want to add a new view only organization?')) {
                return
            }

            // Handle adding new view only org
            projectOrganizationViewOnlyService.save(this.$http, this.project.projectId, this.projectViewOnlyOrganizationId).then(res => {
                this.gridProjectViewOnlyOrganizations.tableData.push(res.data)
            })
        }
    }
}

</script>


<style>

.text-label {
    line-height: 24px !important;
}

.tabContent {
    margin-left: 30px;
}

.sectionHeader {
    overflow: hidden;
    margin-top: 20px;
}

.sectionHeaderLeft {
    float: left;
    font-size: 18px;
}

.sectionHeaderRight {
    float: right;
}

</style>



// WEBPACK FOOTER //
// Project.vue?2cf5e944